import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../../core/services/sidebar.service';
import { ExternalmenuComponent } from '../../../shared/externalmenu/externalmenu.component';

@Component({
  selector: 'app-widgetlayout',
  imports: [ExternalmenuComponent,FormsModule,CommonModule],
  templateUrl: './widgetlayout.html',
  styleUrl: './widgetlayout.scss'
})
export class Widgetlayout  {
  @ViewChild('customCategoryInput') customCategoryInput!: ElementRef;
  public userInfo: any;
  selected = 'W';
  public loading = false;
  Categories: any[] = [];
  Roles: any;
  widgetData: any[] = [];
  selectedRole: any = null;
  dropdownOpen = false;
  logedInUser: any;
  userId: any;
  groupcode: any;
  roleid: any;
  draggedIndex: number | null = null;
  currentPlaceholderId: any;
  roleWidgets: any = {};
  RoleBaseWidgets: any;
  roles: any;
  roleDropdownOpen: boolean = false;
  title: any;
  showModal: boolean = false;
  selectedWidget: any;
  widgetDropdownOpen = false;
  allWidgets: any[] = [];
  availableWidgetNames: any[] = [];
  selectedWidgets: string[] = [];
  showWidgetNameModal = false;
  placeholderWidgets = Array(6)
    .fill(null)
    .map((_, index) => ({ id: index }));
  selectedWidgetMap: { [key: number]: any } = {};
  showDropdownFor: number | null = null;
  widgetids1: any;
  isSidebarCollapsed = false;
  setHeaderData() {
    const HeaderData = {
      title: 'Role Based Widget Dashboard',
    };
    this.apiService.SetHeaderData({ obj: HeaderData });
  }
  constructor(
    private apiService: ApiService,
    private router: Router,
    private sidebarService:SidebarService

  ) {
    this.setHeaderData();
  }
  ngOnInit(): void {


    this.sidebarService.isCollapsed$.subscribe((collapsed: any) => {
      this.isSidebarCollapsed = collapsed;
    });
    this.getWidgets();
    const userStr = localStorage.getItem('userInfo');
    this.logedInUser = userStr ? JSON.parse(userStr) : null;
    const userId = localStorage.getItem('fcmToken');
    this.userId = userId ? JSON.parse(userId) : null;
    this.roleid = this.logedInUser?.user_Info.roleid ?? null;
    this.title = this.logedInUser?.user_Info.title ?? null;
    this.groupcode =
      this.logedInUser?.group === 'CAV1' ? 'CAV' : this.logedInUser?.group;

      console.log('groupcode',this.groupcode);

    this.getroles(this.groupcode);
    // if (this.roleid && this.logedInUser) {
    //   this.getRoleWidgets(this.roleid, this.groupcode);
    // }
  }
  onRoleSelect(role: any) {
        this.loading = true;

    this.selectedRole = role;
    this.roleDropdownOpen = false;
    this.getRoleWidgets(role.Role_Uniqid, role);
    if (role.ROLE_DASHBOARD_POSITION) {
      const widgetPositions = role.ROLE_DASHBOARD_POSITION.split('|')
        .map((item: any) => {
          const match = item.match(
            /widgetid:'(\d+)',widgetsize:'(\d+)',widgetposition:'(\d+)'/
          );
          if (match) {
            return {
              widgetId: +match[1],
              widgetSize: +match[2],
              widgetPosition: +match[3],
            };
          }
          return null;
        })
        .filter(Boolean);
      setTimeout(() => {
        widgetPositions.forEach((pos: any) => {
          const widgetData = this.RoleBaseWidgets.find(
            (w: any) => w.Widget_id === pos.widgetId
          );
          if (widgetData) {
            widgetData.Widget_size = pos.widgetSize;
            this.selectedWidgetMap[pos.widgetPosition] = widgetData;
          }
        });
      }, 0);
    }
  }
  getWidgets() {
    this.loading = true;
    const userStr = localStorage.getItem('userInfo');
    const user = userStr ? JSON.parse(userStr) : null;
    const group = user?.group === 'CAV1' ? 'CAV' : user?.group;

    this.apiService.getMethod(`widgets`).subscribe({
      next: (res: any) => {
        this.allWidgets = res
          .filter((w: any) => w.Widget_Group_Code === group)
          .map((w: any) => ({
            ...w,
            Widget_size: w.Widget_size === 0 ? 0.5 : parseFloat(w.Widget_size),
          }));
        this.availableWidgetNames = [
          ...new Set(this.allWidgets.map((w) => w.Widget_name)),
        ];
        this.selectedWidgets = [];
        this.loading = false;
      },
    });
  }
  getWidgetSize(id: any): number {
    const size = this.selectedWidgetMap[id]?.Widget_size;
    return size && [1, 2, 3, 4,5].includes(size) ? size : 1; // default to 1
  }

  getWidgetColSpan(size: number): number {
    switch (size) {
      case 1: return 4; // small
      case 2: return 6; // wide
      case 3: return 8; // tall
      case 4: return 4; // large
      case 5: return 8;
      default: return 4;
    }
  }
  
  getWidgetRowSpan(size: number): number {
    switch (size) {
      case 1: return 1;
      case 2: return 1;
      case 3: return 1; // tall
      case 4: return 2; // large
      case 5: return 2;
      default: return 1;
    }
  }




  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    this.dropdownOpen = false;
    this.roleDropdownOpen = false;
  }
  resizeWidget(widget: any, action: 'increase' | 'decrease') {
     this.loading=true
    const sizes = [1, 2, 3, 4,5];
    const currentIndex = sizes.indexOf(widget.Widget_size);

    if (action === 'increase' && currentIndex < sizes.length - 1) {

      widget.Widget_size = sizes[currentIndex + 1];
    } else if (action === 'decrease' && currentIndex > 0) {
      widget.Widget_size = sizes[currentIndex - 1];
    }
    Object.keys(this.selectedWidgetMap).forEach((key: any) => {
      if (this.selectedWidgetMap[key]?.Widget_id === widget.Widget_id) {
        this.selectedWidgetMap[key] = { ...widget }; // spread ensures Angular detects changes
      }
    });
    this.updateRoleWidgets(widget, 'toggle');
  }


  toggleRoleDropdown(event: MouseEvent) {
    event.stopPropagation();
    setTimeout(() => {
      this.roleDropdownOpen = !this.roleDropdownOpen;
    }, 0);
  }
  getSelectedRoleName() {
    const selectedRole = this.selectedRole;
    return selectedRole ? selectedRole.Role_Name : 'Select Role';
  }

  getroles(groupcode: any) {
    console.log(groupcode);

    this.loading = true;
    return new Promise((resolve, reject) => {
      this.apiService.getMethod(`/roles/groupcode/${groupcode}`).subscribe({
        next: (res: any) => {
          if (res) {
            this.roles = res.filter((role: any) => role.Role_Status === 'Y');
            this.selectedRole =this.roles.find((role: any) => role.Role_Uniqid == this.roleid) ||
              null;

            if (this.selectedRole) {
              this.getRoleWidgets(
                this.selectedRole.Role_Uniqid,
                this.selectedRole,
                this.groupcode
              );
            }
            resolve(this.roles);
            this.loading = false;
          } else {
            reject('Failed to fetch Data');
            this.loading = false;
          }
        },
      });
    });
  }

  openWidgetNameModal(placeholderId: number) {
    this.currentPlaceholderId = placeholderId;
    const displayedIds = Object.values(this.selectedWidgetMap)
      .filter(Boolean)
      .map((w: any) => w.Widget_id);
    this.availableWidgetNames = this.RoleBaseWidgets.filter(
      (widget: any) => !displayedIds.includes(widget.Widget_id)
    );
    this.showWidgetNameModal = true;
  }
  widgetids: any;
  selectWidgetFor(id: number, widgetName: any): void {
    this.loading=true
    const widget = this.allWidgets.find(
      (w) => w.Widget_name === widgetName.Widget_name
    );
    if (!widget) {
      return;
    }
    this.selectedWidgetMap[id] = widget;
    this.RoleBaseWidgets = this.RoleBaseWidgets.filter(
      (w: any) => w.Widget_name !== widgetName.Widget_name
    );
    this.availableWidgetNames = this.availableWidgetNames.filter(
      (n: any) => n.Widget_name !== widgetName.Widget_name
    );
    this.widgetids = Object.values(this.selectedWidgetMap).map(
      (w: any) => w.Widget_id
    );
    if (this.selectedRole?.Role_Uniqid) {
      this.updateRoleWidgets(widget, 'toggle');
    }
    this.showWidgetNameModal = false;
  }


  getRoleWidgets(roleUniqid: number, role: any, groupCode: string = '') {
    this.selectedWidgetMap = [];
    this.loading = true;
    this.selectedRole = role;
    this.widgetids1 = [];
    this.placeholderWidgets = [];
    const body = { roleUniqid, groupcode: role.groupcode || groupCode };
    this.apiService.postmethod('widgets/byRole', body).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.RoleBaseWidgets = res.data;
          const data = res.role;
          this.widgetids1 = this.RoleBaseWidgets.map((w: any) => w.Widget_id);
          const totalSlots = this.widgetids1?.length || 0;
          this.placeholderWidgets = Array.from(
            { length: totalSlots },
            (_, i) => ({ id: i + 1 })
          );
          if (data.ROLE_DASHBOARD_POSITION) {
            const widgetPositions = data.ROLE_DASHBOARD_POSITION.split('|').map(
              (entry: string) => {
                const parts: any = {};
                entry.split(',').forEach((pair) => {
                  const [key, value] = pair.split(':');
                  if (key && value) {
                    parts[key.trim()] = value.replace(/'/g, '').trim();
                  }
                });
                return {
                  widgetId: Number(parts.widgetid),
                  widgetSize: Number(parts.widgetsize),
                  widgetPosition: Number(parts.widgetposition),
                };
              }
            );
            widgetPositions.forEach((pos: any) => {
              const widgetData = this.RoleBaseWidgets.find(
                (w: any) => w.Widget_id === pos.widgetId
              );
              if (widgetData) {
                widgetData.Widget_size = pos.widgetSize;
                this.selectedWidgetMap[pos.widgetPosition] = widgetData;
              }
            });
          } else {
            this.RoleBaseWidgets.forEach((widget: any) => {
              const placeholder = this.placeholderWidgets.find(
                (p) => p.id === widget.Widget_placeholder_id
              );
              if (placeholder) {
                this.selectedWidgetMap[placeholder.id] = widget;
              }
            });
          }
        }
        this.loading = false;
      },
    });
  }
  removeWidget(widget: any) {
    this.loading=true
    if (!this.selectedRole) return;
this.loading=true
    const widgetId = widget.Widget_id;
    let roleWidgetIds = this.selectedRole.Role_widgets
      ? this.selectedRole.Role_widgets.split(',').map((id: any) => +id)
      : [];
    roleWidgetIds = roleWidgetIds.filter((id: any) => id !== widgetId);
    this.selectedRole.Role_widgets = roleWidgetIds.join(',');
    for (const key in this.selectedWidgetMap) {
      if (this.selectedWidgetMap[key]?.Widget_id === widgetId) {
        delete this.selectedWidgetMap[key];
        break;
      }
    }
    if (
      !this.RoleBaseWidgets.some(
        (w: { Widget_id: any }) => w.Widget_id === widget.Widget_id
      )
    ) {
      this.RoleBaseWidgets.push(widget);
    }
    if (
      !this.availableWidgetNames.some(
        (w) => w.Widget_name === widget.Widget_name
      )
    ) {
      this.availableWidgetNames.push({ Widget_name: widget.Widget_name });
    }
    const dashBoardSeqStr = this.placeholderWidgets
      .map((ph) => {
        const w = this.selectedWidgetMap[ph.id];
        if (!w) return null;
        return `widgetid:'${w.Widget_id}',widgetsize:'${w.Widget_size}',widgetposition:'${ph.id}'`;
      })
      .filter((seq) => seq !== null)
      .join('|');
    const axelWidgetsList = Array.isArray(this.widgetids1)
      ? this.widgetids1
      : [];

    if(axelWidgetsList.length < 1){
     return
     }


    const obj = {
      axelWidgets: axelWidgetsList.join(','),
      updatedUserId: this.selectedRole.Role_Uniqid,
      dashBoardSeq: dashBoardSeqStr,
    };

    const roleId = this.selectedRole.Role_Uniqid;
    const groupCode = this.groupcode;
    this.apiService
      .putmethod(`roles/${roleId}/${groupCode}/axelglobal-widgets`, obj)
      .subscribe({
        next: (res) => {
          console.log("Mossy widgets updated:", res);
          this.loading=false
        },
        error: (err) => {
          console.error("Mossy API error:", err);
          this.loading=false
        }
      });


  }


  onDragStart(event: DragEvent, index: number) {
    this.draggedIndex = index;
    const card = (event.target as HTMLElement).closest(
      '.widget-card'
    ) as HTMLElement;
    if (card) {
      card.classList.add('dragging');
    }
    event.dataTransfer?.setDragImage(new Image(), 0, 0);
  }

  onDragEnd(event: DragEvent) {
    const card = (event.target as HTMLElement).closest(
      '.widget-card'
    ) as HTMLElement;
    if (card) {
      card.classList.remove('dragging');
    }
    this.draggedIndex = null;
  }

  onDragOver(event: DragEvent, index: number) {
    event.preventDefault();
  }

  onDrop(event: DragEvent, index: number) {
    event.preventDefault();
    if (this.draggedIndex === null || this.draggedIndex === index) return;

    const targetPlaceholder = this.placeholderWidgets[index];
    const isTargetEmpty = !this.selectedWidgetMap[targetPlaceholder.id];

    if (isTargetEmpty) {
      return;
    }
    const temp = this.placeholderWidgets[this.draggedIndex];
    this.placeholderWidgets[this.draggedIndex] = this.placeholderWidgets[index];
    this.placeholderWidgets[index] = temp;
    this.draggedIndex = null;
    this.updateRoleWidgets(this.placeholderWidgets, 'drag');
  }
  updateRoleWidgets(widget: any, mode: 'drag' | 'toggle') {
    console.log('widgetttttttttt',widget);

    if (!this.selectedRole) return;

    const widgetId = widget.Widget_id;
    let roleWidgetIds = this.selectedRole.Role_widgets
      ? this.selectedRole.Role_widgets.split(',').map((id: string) => +id)
      : [];
    roleWidgetIds = roleWidgetIds.includes(widgetId)
      ? roleWidgetIds.filter((id: any) => id !== widgetId)
      : [...roleWidgetIds, widgetId];

    this.selectedRole.Role_widgets = roleWidgetIds.join(',');
    let dashBoardSeqStr = '';
    if (mode === 'drag') {
      const updatedWidgets = this.placeholderWidgets
        .filter((ph) => this.selectedWidgetMap[ph.id])
        .map((ph, idx) => {
          const w = this.selectedWidgetMap[ph.id];
          w.Widget_sequence = idx + 1;
          return w;
        });

      dashBoardSeqStr = updatedWidgets
        .map(
          (w) =>
            `widgetid:'${w.Widget_id}',widgetsize:'${w.Widget_size}',widgetposition:'${w.Widget_sequence}'`
        )
        .join('|');
    } else if (mode === 'toggle') {
      dashBoardSeqStr = this.placeholderWidgets
        .filter((ph) => this.selectedWidgetMap[ph.id])
        .map((ph) => {
          const w = this.selectedWidgetMap[ph.id];
          return `widgetid:'${w.Widget_id}',widgetsize:'${w.Widget_size}',widgetposition:'${ph.id}'`;
        })
        .join('|');
    }
    const axelWidgetsList = Array.isArray(this.widgetids1)
      ? this.widgetids1
      : [];
      if(axelWidgetsList.length < 1){
        return
        }
    const obj = {
      axelWidgets: axelWidgetsList.join(','),
      updatedUserId: this.selectedRole.Role_Uniqid,
      dashBoardSeq: dashBoardSeqStr,
    };
    const roleId = this.selectedRole.Role_Uniqid;
    const groupCode = this.groupcode;
    this.apiService
      .putmethod(`roles/${roleId}/${groupCode}/axelglobal-widgets`, obj)
      .subscribe({
        next: () => {
          if (mode === 'toggle') {
            this.selectedWidgetMap = [];
          }
          this.getRoleWidgets(
            this.selectedRole.Role_Uniqid,
            this.selectedRole,
            this.groupcode
          );
        },
      });
    this.loading=false
  }
}
